import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { BrowserDocumentService } from 'pf-frontend-common/src/service/browser-document/service';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { MapboxMapsCss } from 'common/module/mapbox/maps/css';

export function MapboxMapsCssFactory(): MapboxMapsCss {
  return new MapboxMapsCss(EventEmitterFactory(), BrowserDocumentService(), WindowService());
}
